// Auto-generated registered query names
// DO NOT EDIT - Changes will be overwritten
//
// Use these instead of string literals for the `query_name`
// field sent to /api/query — a renamed/removed backend query
// then fails compilation instead of failing at runtime.
// Names are canonical '{module}-{name}' wire names — the only
// form the server resolves.

export const QueryNames = {
  baseAllInvites: 'base-all-invites',
  baseAllOrganisations: 'base-all-organisations',
  baseAllUsers: 'base-all-users',
  baseAllWorkspaces: 'base-all-workspaces',
  baseEffectiveRoster: 'base-effective-roster',
  baseOrganisationById: 'base-organisation-by-id',
  baseUserById: 'base-user-by-id',
  baseUsersByIdentifiers: 'base-users-by-identifiers',
  chatModelRequestById: 'chat-model-request-by-id',
  chatModelRequestWithResponse: 'chat-model-request-with-response',
  chatModelResponseById: 'chat-model-response-by-id',
  chatModelResponseWithParts: 'chat-model-response-with-parts',
  chatStepById: 'chat-step-by-id',
  chatStepWithRequests: 'chat-step-with-requests',
  chatThreadById: 'chat-thread-by-id',
  chatThreadStepsRequests: 'chat-thread-steps-requests',
  chatThreadWithIncludes: 'chat-thread-with-includes',
  chatThreadWithSteps: 'chat-thread-with-steps',
  pdmActionById: 'pdm-action-by-id',
  pdmProductById: 'pdm-product-by-id',
  pdmProductWithActions: 'pdm-product-with-actions',
  pdmProductWithIncludes: 'pdm-product-with-includes',
  pdmProductWithRequirements: 'pdm-product-with-requirements',
  pdmProductWithSupplyChain: 'pdm-product-with-supply-chain',
  pdmProductsList: 'pdm-products-list',
  pdmSearchContextItems: 'pdm-search-context-items',
  pdmTasksWorkspaceWithProducts: 'pdm_tasks-workspace-with-products',
  rflpActionById: 'rflp-action-by-id',
  rflpActionInputParameterById: 'rflp-action-input-parameter-by-id',
  rflpActionOutputParameterById: 'rflp-action-output-parameter-by-id',
  rflpAnalysisRecordById: 'rflp-analysis-record-by-id',
  rflpAttributeValueById: 'rflp-attribute-value-by-id',
  rflpChangeImpactById: 'rflp-change-impact-by-id',
  rflpChangeProposalById: 'rflp-change-proposal-by-id',
  rflpConnectionById: 'rflp-connection-by-id',
  rflpConstraintById: 'rflp-constraint-by-id',
  rflpControlPortById: 'rflp-control-port-by-id',
  rflpDerivedExpressionById: 'rflp-derived-expression-by-id',
  rflpDerivedValueById: 'rflp-derived-value-by-id',
  rflpDiscreteAttributeById: 'rflp-discrete-attribute-by-id',
  rflpInterfacePortById: 'rflp-interface-port-by-id',
  rflpItemById: 'rflp-item-by-id',
  rflpItemFlowById: 'rflp-item-flow-by-id',
  rflpLogicalPartById: 'rflp-logical-part-by-id',
  rflpNumericAttributeById: 'rflp-numeric-attribute-by-id',
  rflpPhysicalPartById: 'rflp-physical-part-by-id',
  rflpPhysicsPortById: 'rflp-physics-port-by-id',
  rflpProjectById: 'rflp-project-by-id',
  rflpProjectChangeImpacts: 'rflp-project-change-impacts',
  rflpProposalBatchById: 'rflp-proposal-batch-by-id',
  rflpRequirementById: 'rflp-requirement-by-id',
  rflpSoftwarePartById: 'rflp-software-part-by-id',
  rflpStandardById: 'rflp-standard-by-id',
  rflpSuccessionById: 'rflp-succession-by-id',
  rflpUnitById: 'rflp-unit-by-id',
  rflpTasksSearchRflpContextItemsProject: 'rflp_tasks-search-rflp-context-items-project',
  rflpTasksSearchRflpContextItemsWorkspace: 'rflp_tasks-search-rflp-context-items-workspace',
  tasksWorkspaceTasks: 'tasks-workspace-tasks',
  tasksWorkspaceThreads: 'tasks-workspace-threads',
  versioningBranches: 'versioning-branches',
  versioningCommitByProgress: 'versioning-commit-by-progress',
  versioningCommitHistory: 'versioning-commit-history',
  versioningCommitOps: 'versioning-commit-ops',
  versioningOverlays: 'versioning-overlays',
  versioningProposals: 'versioning-proposals',
  versioningReleases: 'versioning-releases',
  versioningWorkingOps: 'versioning-working-ops',
} as const;

export type QueryName = (typeof QueryNames)[keyof typeof QueryNames];
